import { Link, useLocation } from 'react-router-dom'
import { usePainelDoCredito } from '../api/queries/creditoDaIa'
import { temPermissao, useSessao } from '../auth/contexto'
import { TEXTOS } from '../lib/glossario'

/**
 * A tarja do crédito de IA, em todo `/admin/*`.
 *
 * **Tarja, e não aviso passageiro:** um toast some e o problema não. Enquanto o mês estiver na
 * reserva ou esgotado, quem administra vê isso em toda tela de administração — junto com a
 * pendência do painel, que é o outro canal que hoje chega a uma pessoa.
 *
 * **Só em `/admin/*`, e só para quem administra.** Fora dali ela seria um valor em reais ao lado da
 * fiscalização, que é a leitura que a V31 recusou — e é por isso que a tarja não mostra número
 * nenhum: ela diz o que parou e para onde ir.
 *
 * @returns a tarja, ou nada quando não há o que avisar
 */
export function TarjaDeOrcamento() {
  const local = useLocation()
  const { usuario } = useSessao()
  // Duas chaves antes de qualquer consulta: o endereço e a permissão. Sem elas, um fiscal na tela
  // de chamados dispararia a consulta do saldo — e o servidor a recusaria, com 403 no console a
  // cada troca de tela.
  const mostrar = local.pathname.startsWith('/admin') && temPermissao(usuario, 'USUARIOS_ADMINISTRAR')
  const { data: painel } = usePainelDoCredito(undefined, mostrar)

  const saldo = painel?.saldo
  if (!mostrar || !saldo || (!saldo.naReserva && !saldo.esgotado)) {
    return null
  }

  const t = TEXTOS.creditoDaIa.saldo
  const cores = saldo.esgotado
    ? 'border-red-300 bg-red-50 text-red-900'
    : 'border-amber-300 bg-amber-50 text-amber-900'

  return (
    <div className={`mb-4 rounded-lg border px-4 py-3 text-sm ${cores}`}>
      <p className="max-w-prose">{saldo.esgotado ? t.esgotado : t.naReserva}</p>
      {local.pathname !== '/admin/credito-da-ia' && (
        <Link to="/admin/credito-da-ia" className="mt-1 inline-block text-xs font-medium underline underline-offset-2">
          Abrir o crédito de IA
        </Link>
      )}
    </div>
  )
}
